import * as types from '../email-verify-input-types';

const defaultState = {
    hasError: false,
    error: null,
    inputErrorState: false,
    emailVerified: false,
    emailVerifyAttempted: false,
    email: '',
    isValidatingEmail: false
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case types.FAILED:
            return Object.assign({}, state, { hasError: !state.hasError, ...action.data });
            break;
        case types.EMAIL_OVERRIDE:
            return Object.assign({}, state, action.data);
            break;
        case types.RESET:
            return Object.assign({}, defaultState);
            break;
        case types.FETCHING:
        case types.EMAIL_CHANGED:
        case types.RECEIVED_VERIFY_RESULT:
        case types.CHECK_EMAIL_INPUT_STATE:
            return { ...state, ...action.data };
        default:
            return Object.assign({}, state);
            break;
    }
};

export default reducer;
